import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function BespokeHub() {
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/bespoke-categories").then(({ data }) => setCats(data || [])).catch(() => {});
  }, []);

  return (
    <main data-testid="bespoke-hub">
      <div className="sq-container pt-14 pb-4 text-center">
        <div className="sq-eyebrow text-squire-jeans">The Atelier</div>
        <h1 className="font-display text-5xl md:text-6xl mt-2">Tailor Made</h1>
        <p className="text-[#4B5563] mt-3 max-w-lg mx-auto">Pick a category — every measurement, fabric and finish is built around you.</p>
      </div>

      <div className="sq-container py-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {cats.map((c, i) => (
          <motion.div
            key={c.key}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
          >
            <Link
              to={`/bespoke/${c.key}`}
              data-testid={`bespoke-hub-${c.key}`}
              className="group relative block aspect-[4/5] overflow-hidden bg-black"
            >
              <img src={c.image} alt={c.hub_label || c.label} className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-95 group-hover:scale-105 transition-all duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="font-display text-white text-2xl md:text-3xl">{c.hub_label || c.label}</div>
                <p className="text-white/75 text-sm mt-2 max-w-[26ch]">{c.hub_subtitle || c.tagline}</p>
                <div className="mt-5 inline-flex items-center gap-2 bg-squire-jeans text-white text-[11px] uppercase tracking-[0.2em] font-semibold px-5 py-3 group-hover:bg-white group-hover:text-black transition-colors">
                  Start Customizing <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>

      <div className="sq-container pb-20 text-center">
        <p className="text-sm text-[#4B5563]">Already know your measurements? <Link to="/bespoke/start" data-testid="bespoke-hub-quick-start" className="text-squire-jeans hover:underline">Jump straight to the order form</Link></p>
      </div>
    </main>
  );
}
